const configList = {
  // 进行中的抽奖期数
  progress: `/lottery/v1/running/lottery/period`,
  // 历史开奖期数信息
  history: `/lottery/v1/history/lottery/period`,
  // 用户抽奖期数信息
  myRecord: `/lottery/v1/user/lottery/period`,
  // 获取当前用户抽奖券总数以及中奖飘屏信息
  homePage: `/lottery/v1/lottery/home/page`,
  // 获取奖池详情信息
  detail: `/lottery/v1/lottery/pool/detail`,
  // 券消耗明细
  couponDetail: `/lottery/v1/ticket/consume/detail`,
  // 获取用户生效中的抽奖券
  userTicket: `/lottery/v1/user/effective/lottery/ticket`,
  // 使用兑换码
  code: `/lottery/use/redemption/code`,
  // 获取更多抽奖券
  entrance: `/lottery/activity/entrance`,
  // 投入奖池时获取可使用奖券的数量和类型
  ticketDetail: `/lottery/v1/ticket/detail`,
  // 获取奖池历史中奖名单以及商品信息
  winList: `/lottery/v1/lottery/pool/history/win/list`,
  // 获取抽奖基础信息
  basic: `/lottery/basic`,
  // 中奖弹窗
  prompt: `/lottery/v1/win/prompt`,
  // 确认收货地址
  confirmAddress: `/lottery/confirm/address`,
  // 中奖展示埋点上报
  report: `/lottery/show/report`,
  // 奖券确认投入奖池
  confirm: `/lottery/v1/ticket/use/confirm`,
  // 获取奖池中奖结果
  winInfo: `/lottery/v1/lottery/pool/win/info`,
  // 获取奖池期数用户抽奖券信息
  ticketNum: `/lottery/v1/user/ticketNum`,
  // 埋点
  reportCollect: `/trilateral/mutual/pre/payment/report`,
  // 过期券展示关闭事件上报
  closeReport: `/lottery/ticket/expire/close/report`,
  // 获取更多抽奖券
  entranceV1: `/lottery/v1/activity/entrance`,
  // 查询游戏等级
  gameInfo: `/activity/a1013/search/game/info`,
  // 生成邀请码
  inviteCode: `/activity/a1013/generate/invite/code`,
  // 填写邀请码
  fillInviteCode: `/activity/a1013/use/invite/code`,
  // 新人精选顶部配置
  newbieSelectedConfig: `/box/v1/h5/newbie/selected/config`,
  // 新人精选游戏列表
  newbieSelectedPage: `/box/v1/h5/newbie/selected/page`,
  // 新人精选返回挽留弹窗
  newbieSelectedLeaveGuide: `/box/v1/h5/newbie/selected/leave-guide`,
};

export default (baseApi: string) => {
  const obj = {};
  for (const key of Object.keys(configList)) {
    obj[key] = `${baseApi}${configList[key]}`;
  }
  return obj;
};
